enum ETourSteps {
  LIST_STATEMENTS = 'list-statements',
  NEW_STATEMENT_STEP_3 = 'new-statement-step-3',
}

export default ETourSteps;